import { createSelector } from '@reduxjs/toolkit';

import {
  selectAdjustmentVersion,
  selectCalculatorVersion,
  selectCostMultiplier,
  selectDataSetVersion,
  selectEffectiveYear,
} from '../orderSelectors.ts';

export const selectAdjustmentProps = createSelector(
  [
    selectDataSetVersion,
    selectCalculatorVersion,
    selectAdjustmentVersion,
    selectCostMultiplier,
    selectEffectiveYear,
  ],
  (datasetVersion, calculatorVersion, adjustmentVersion, costMultiplier, effectiveYear) => ({
    datasetVersion,
    calculatorVersion,
    adjustmentVersion,
    costMultiplier,
    effectiveYear,
  }),
);
